import { Style } from 'inlines'

export const OverlayContent = ({
  children,
  style,
}: {
  children?: React.ReactNode
  style?: Style
}) => {
  return children
}
